import React, { useEffect } from 'react'
import { 
    AppBar, 
    Dialog, 
    DialogContent, 
    IconButton, 
    makeStyles, 
    Toolbar, 
    Typography 
} from '@material-ui/core'
import StepperTurnos from '../../../../turnos/nuevo/StepperTurnos'
import { CloseSharp } from '@material-ui/icons';
import { traerAfiliadoXId } from '../../../../../actions/afiliado';
import { useDispatch } from 'react-redux';
import { changeStepper } from '../../../../../actions/preAfiliado/stepper';
import { OBRAS_SOCIALES } from '../../../../../utils/constants';
import { getDatosPreviosDeAfiliadoExterno } from '../../../../../actions/afiliadoExterno';

const useStyles = makeStyles((theme) => ({
    appBar: {
        position: 'relative',
    },
    title: {
        marginLeft: theme.spacing(2),
        flex: 1,
    },
}));

export const ModalAltaTurno = (props) => {
    const classes = useStyles();
    const dispatch = useDispatch();

    const { afiliado, idObraSocial, hce, idEfectorRed } = props;

    useEffect(() => {
        if (hce?.idObraSocial !== OBRAS_SOCIALES.OSPEDYC) {
            dispatch(getDatosPreviosDeAfiliadoExterno(hce?.idObraSocial, afiliado));
        }
        else {
            dispatch(traerAfiliadoXId(afiliado?.id_afiliado))
        }
        dispatch(changeStepper(2));
    }, [dispatch]);


  console.log(idEfectorRed)

    return (
        <React.Fragment>
            <Dialog fullScreen maxWidth="xl" open={props.open}>
                <AppBar className={classes.appBar}>
                    <Toolbar>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={props.closeModalHandler}
                            aria-label="close"
                        >
                            <CloseSharp />
                        </IconButton>
                        <Typography variant="h6" >
                            Ingreso Turno
                        </Typography>
                    </Toolbar>
                </AppBar>
                <DialogContent>
                    <StepperTurnos 
                        desdeHce={true} 
                        idOS={idObraSocial} 
                        idEfectorHce={idEfectorRed}
                        cerrarHce={props.closeModalHandler}
                    />
                </DialogContent>
            </Dialog>
        </React.Fragment>
    )
}
